import React, {useMemo} from "react";
import {css} from "@panda/css";
import cn from "classnames";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon, BrandSearchIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {IOption} from "@pg-design/select-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {kmUrl} from "../../../../app/read_rp_environment_variables";
import {useGetRegionDetailListQuery} from "../../../../region/api/get_region_detail_list";
import {SearchTab} from "../../../../search/types/SearchTab";
import {getSearchUrlWithFilters} from "../../../../search/utils/get_search_url_with_filters";
import {IPreferencesDefaultValues} from "../../../types/IPreferencesDefaultValues";
import {PreferencesModalHeading} from "./PreferencesModalHeading";

interface IProps {
    preferences: IPreferencesDefaultValues;
    multipleLeadsSend: boolean;
}

const kmLink = kmUrl + "/rynekpierwotny/oferty/moje-zapytania/";

export const PreferencesSummary = (props: IProps) => {
    const regionIds = useMemo(() => props.preferences.regions.map((region: IOption<number>) => region.value), [props.preferences]);

    const {data, isLoading} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});

    const listingLink = getSearchUrlWithFilters({
        singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: {},
        searchFormValues: {
            rooms: props.preferences.rooms,
            search: {
                label: "",
                tabType: SearchTab.Regions,
                regions: data || []
            },
            price: {upper: props.preferences.budget},
            type: [],
            area: null,
            floor_choices: [],
            construction_end_date: null,
            distance: null,
            house_type: null,
            house_additional_areas: null,
            house_storeys: null,
            instalment: null
        },
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
    }).url;

    return (
        <div>
            <PreferencesModalHeading multipleLeadsSend={props.multipleLeadsSend} />
            <div className={cn(sectionBox, sectionMB, mbStyle)}>
                <BrandHandclapIcon size="4.4" wrapperSize="4.4" wrapperColor={getThemeVariable("colors.primary")} />
                <div>
                    <Text variant="headline_5" as="p" className={titleStyle}>
                        Sprawdź swoje konto mieszkaniowe
                    </Text>
                    <Text variant="body_copy_2">
                        Od teraz będziemy mogli rekomendować Ci najbardziej dopasowane do Twoich potrzeb nieruchomości za pośrednictwem przygotowanego dla
                        Ciebie <b>Konta Mieszkaniowego</b>. Dzięki <b>automatycznym rekomendacjom i skrzynce odbiorczej</b> twoje poszukiwania wymarzonego M
                        staną się skuteczniejsze i bardziej zorganizowane.
                    </Text>
                    <Button variant="filled_primary" href={kmLink || ""} target="_blank" size="small" type="button" className={mbStyle}>
                        zobacz, jak działa konto
                    </Button>
                </div>
            </div>
            <div className={sectionBox}>
                <BrandSearchIcon size="4.4" wrapperSize="4.4" wrapperColor={getThemeVariable("colors.primary")} />
                <div>
                    <Text variant="headline_5" as="p" className={titleStyle}>
                        Kontynuuj poszukiwania
                    </Text>
                    <Text variant="body_copy_2">Zobacz wszystkie oferty które spełniają określone przez Ciebie kryteria</Text>
                    <Button variant="outlined_secondary" href={listingLink} target="_blank" size="small" type="button" className={mbStyle} disabled={isLoading}>
                        {isLoading ? <Loader size="sm" /> : "kontynuuj poszukiwania"}
                    </Button>
                </div>
            </div>
        </div>
    );
};

const sectionBox = css({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "row",
    p: 2,
    background: "var(--colors-gray-100)",
    gap: 2
});

const titleStyle = css({
    mb: 1
});

const sectionMB = css({
    mb: 3
});

const mbStyle = css({
    mt: 3
});
import React, {useMemo} from "react";
import {css} from "@panda/css";
import cn from "classnames";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon, BrandSearchIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {IOption} from "@pg-design/select-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {kmUrl} from "../../../../app/read_rp_environment_variables";
import {useGetRegionDetailListQuery} from "../../../../region/api/get_region_detail_list";
import {SearchTab} from "../../../../search/types/SearchTab";
import {getSearchUrlWithFilters} from "../../../../search/utils/get_search_url_with_filters";
import {IPreferencesDefaultValues} from "../../../types/IPreferencesDefaultValues";
import {PreferencesModalHeading} from "./PreferencesModalHeading";

interface IProps {
    preferences: IPreferencesDefaultValues;
    multipleLeadsSend: boolean;
}

const kmLink = kmUrl + "/rynekpierwotny/oferty/moje-zapytania/";

export const PreferencesSummary = (props: IProps) => {
    const regionIds = useMemo(() => props.preferences.regions.map((region: IOption<number>) => region.value), [props.preferences]);

    const {data, isLoading} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});

    const listingLink = getSearchUrlWithFilters({
        singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: {},
        searchFormValues: {
            rooms: props.preferences.rooms,
            search: {
                label: "",
                tabType: SearchTab.Regions,
                regions: data || []
            },
            price: {upper: props.preferences.budget},
            type: [],
            area: null,
            floor_choices: [],
            construction_end_date: null,
            distance: null,
            house_type: null,
            house_additional_areas: null,
            house_storeys: null,
            instalment: null
        },
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
    }).url;

    return (
        <div>
            <PreferencesModalHeading multipleLeadsSend={props.multipleLeadsSend} />
            <div className={cn(sectionBox, sectionMB, mbStyle)}>
                <BrandHandclapIcon size="4.4" wrapperSize="4.4" wrapperColor={getThemeVariable("colors.primary")} />
                <div>
                    <Text variant="headline_5" as="p" className={titleStyle}>
                        Sprawdź swoje konto mieszkaniowe
                    </Text>
                    <Text variant="body_copy_2">
                        Od teraz będziemy mogli rekomendować Ci najbardziej dopasowane do Twoich potrzeb nieruchomości za pośrednictwem przygotowanego dla
                        Ciebie <b>Konta Mieszkaniowego</b>. Dzięki <b>automatycznym rekomendacjom i skrzynce odbiorczej</b> twoje poszukiwania wymarzonego M
                        staną się skuteczniejsze i bardziej zorganizowane.
                    </Text>
                    <Button variant="filled_primary" href={kmLink || ""} target="_blank" size="small" type="button" className={mbStyle}>
                        zobacz, jak działa konto
                    </Button>
                </div>
            </div>
            <div className={sectionBox}>
                <BrandSearchIcon size="4.4" wrapperSize="4.4" wrapperColor={getThemeVariable("colors.primary")} />
                <div>
                    <Text variant="headline_5" as="p" className={titleStyle}>
                        Kontynuuj poszukiwania
                    </Text>
                    <Text variant="body_copy_2">Zobacz wszystkie oferty które spełniają określone przez Ciebie kryteria</Text>
                    <Button variant="outlined_secondary" href={listingLink} target="_blank" size="small" type="button" className={mbStyle} disabled={isLoading}>
                        {isLoading ? <Loader size="sm" /> : "kontynuuj poszukiwania"}
                    </Button>
                </div>
            </div>
        </div>
    );
};

const sectionBox = css({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "row",
    p: 2,
    background: "var(--colors-gray-100)",
    gap: 2
});

const titleStyle = css({
    mb: 1
});

const sectionMB = css({
    mb: 3
});

const mbStyle = css({
    mt: 3
});
